import { Container, Row, Col } from "react-bootstrap";
import { motion } from "framer-motion";
import NavbarSection from "../components/NavbarSection";
import FooterSection from "../components/FooterSection";
 
const Privacy = () => {
  return (
    <>
      {/* Navbar without vector background */}
      <div style={{ 
        backgroundColor: "#f0f0f0",
        paddingBottom: "20px" 
      }}>
        <NavbarSection  />
      </div>

      {/* Privacy Policy Section */}
      <div style={{ 
        backgroundColor: "#f0f0f0", 
        minHeight: "100vh",
        padding: "80px 0"
      }}>
        <Container>
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
          >
            <Row className="justify-content-center">
              <Col lg={10}>
                {/* Header */}
                <h1 style={{ 
                  fontSize: "3.5rem", 
                  fontWeight: "700",
                  color: "#1a1a2e",
                  marginBottom: "1rem",
                  lineHeight: "1.2"
                }}>
                  PRIVACY POLICY
                </h1>
                
                <p style={{ 
                  fontSize: "1rem", 
                  color: "#666",
                  marginBottom: "3rem"
                }}>
                  Last updated July 11, 2025
                </p>

                {/* Introduction */}
                <div style={{ marginBottom: "3rem" }}>
                  <p style={{ 
                    fontSize: "1.05rem", 
                    color: "#4a4a4a",
                    lineHeight: "1.7"
                  }}>
                    This Privacy Notice for <strong>Swecha LLC</strong> (doing business as <strong>Writeoffgenie</strong>) ("we," "us," or "our"), describes how and why we might access, collect, store, use, and/or share ("process") your personal information when you use our services ("Services"), including when you:
                  </p>
                  
                  <ul style={{ 
                    fontSize: "1.05rem", 
                    color: "#4a4a4a",
                    lineHeight: "1.9",
                    marginTop: "1rem",
                    marginBottom: "1.5rem"
                  }}>
                    <li className="mb-2">Visit our website at <a href="http://www.writeoffgenie.ai" style={{ color: "#08a040ff", textDecoration: "none" }}>http://www.writeoffgenie.ai</a> or any website of ours that links to this Privacy Notice</li>
                    <li className="mb-2">Download and use our mobile application (WriteOffGenie), or any other application of ours that links to this Privacy Notice</li>
                    <li className="mb-2">Use WriteOffGenie. WriteOffGenie is a mobile-first app designed to help small business owners, freelancers, and solopreneurs simplify tax deductions.</li>
                    <li>Engage with us in other related ways, including any sales, marketing, or events</li>
                  </ul>

                  <p style={{ 
                    fontSize: "1.05rem", 
                    color: "#4a4a4a",
                    lineHeight: "1.7"
                  }}>
                    <strong>Questions or concerns?</strong> Reading this Privacy Notice will help you understand your privacy rights and choices. If you do not agree with our policies and practices, please do not use our Services. If you still have any questions or concerns, please contact us at{" "}
                    <a href="mailto:support@writeoffgenie.ai" style={{ color: "#08a040ff", textDecoration: "none" }}>
                      support@writeoffgenie.ai
                    </a>.
                  </p>
                </div>

                {/* Summary of Key Points */}
                <section style={{ marginBottom: "3rem" }}>
                  <h2 style={{ 
                    fontSize: "2rem", 
                    fontWeight: "700",
                    color: "#1a1a2e",
                    marginBottom: "1.5rem"
                  }}>
                    SUMMARY OF KEY POINTS
                  </h2>
                  
                  <p style={{ 
                    fontSize: "1.05rem", 
                    color: "#4a4a4a",
                    lineHeight: "1.7",
                    marginBottom: "1rem"
                  }}>
                    This summary provides key points from our Privacy Notice, but you can find out more details about any of these topics by using our table of contents below to find the section you are looking for.
                  </p>

                  <div style={{ fontSize: "1rem", color: "#4a4a4a", lineHeight: "1.8" }}>
                    <p className="mb-3"><strong>What personal information do we process?</strong> When you visit, use, or navigate our Services, we may process personal information depending on how you interact with us and the Services, the choices you make, and the products and features you use.</p>
                    
                    <p className="mb-3"><strong>Do we process any sensitive personal information?</strong> We do not process sensitive personal information.</p>
                    
                    <p className="mb-3"><strong>How do we process your information?</strong> We process your information to provide, improve, and administer our Services, communicate with you, for security and fraud prevention, and to comply with law.</p>
                    
                    <p className="mb-3"><strong>How do we keep your information safe?</strong> We have adequate organizational and technical processes and procedures in place to protect your personal information. However, no electronic transmission over the internet can be guaranteed to be 100% secure.</p>
                    
                    <p className="mb-0"><strong>What are your rights?</strong> Depending on where you are located geographically, the applicable privacy law may mean you have certain rights regarding your personal information.</p>
                  </div>
                </section>

                {/* Table of Contents */}
                <section style={{ marginBottom: "3rem" }}>
                  <h2 style={{ 
                    fontSize: "2rem", 
                    fontWeight: "700",
                    color: "#1a1a2e",
                    marginBottom: "1.5rem"
                  }}>
                    TABLE OF CONTENTS
                  </h2>
                  
                  <ol style={{ fontSize: "1rem", color: "#4a4a4a", lineHeight: "1.9" }}>
                    <li>WHAT INFORMATION DO WE COLLECT?</li>
                    <li>HOW DO WE PROCESS YOUR INFORMATION?</li>
                    <li>WHEN AND WITH WHOM DO WE SHARE YOUR PERSONAL INFORMATION?</li>
                    <li>DO WE USE COOKIES AND OTHER TRACKING TECHNOLOGIES?</li>
                    <li>DO WE OFFER ARTIFICIAL INTELLIGENCE-BASED PRODUCTS?</li>
                    <li>HOW LONG DO WE KEEP YOUR INFORMATION?</li>
                    <li>HOW DO WE KEEP YOUR INFORMATION SAFE?</li>
                    <li>DO WE COLLECT INFORMATION FROM MINORS?</li>
                    <li>WHAT ARE YOUR PRIVACY RIGHTS?</li>
                    <li>CONTROLS FOR DO-NOT-TRACK FEATURES</li>
                    <li>DO UNITED STATES RESIDENTS HAVE SPECIFIC PRIVACY RIGHTS?</li>
                    <li>DO WE MAKE UPDATES TO THIS NOTICE?</li>
                    <li>HOW CAN YOU CONTACT US ABOUT THIS NOTICE?</li>
                    <li>HOW CAN YOU REVIEW, UPDATE, OR DELETE THE DATA WE COLLECT FROM YOU?</li>
                  </ol>
                </section>

                {/* 1. What Information Do We Collect */}
                <section style={{ marginBottom: "3rem" }}>
                  <h2 style={{ 
                    fontSize: "2rem", 
                    fontWeight: "700",
                    color: "#1a1a2e",
                    marginBottom: "1.5rem"
                  }}>
                    1. WHAT INFORMATION DO WE COLLECT?
                  </h2>
                  
                  <h3 style={{ fontSize: "1.3rem", fontWeight: "600", color: "#1a1a2e", marginBottom: "1rem" }}>
                    Personal information you disclose to us
                  </h3>
                  
                  <p style={{ fontSize: "1.05rem", color: "#4a4a4a", lineHeight: "1.7", marginBottom: "1rem" }}>
                    <em>In Short:</em> We collect personal information that you provide to us.
                  </p>

                  <p style={{ fontSize: "1.05rem", color: "#4a4a4a", lineHeight: "1.7", marginBottom: "1rem" }}>
                    We collect personal information that you voluntarily provide to us when you register on the Services, express an interest in obtaining information about us or our products and Services, when you participate in activities on the Services, or otherwise when you contact us.
                  </p>

                  <p style={{ fontSize: "1.05rem", color: "#4a4a4a", lineHeight: "1.7", marginBottom: "0.5rem" }}>
                    <strong>Personal Information Provided by You.</strong> The personal information we collect may include:
                  </p>

                  <ul style={{ fontSize: "1rem", color: "#4a4a4a", lineHeight: "1.8", marginBottom: "1.5rem" }}>
                    <li>Names</li>
                    <li>Email addresses</li>
                    <li>Usernames</li>
                    <li>Passwords</li>
                    <li>Phone numbers</li>
                    <li>Billing addresses</li>
                    <li>Business expense details and tax-related descriptions</li>
                  </ul>

                  <p style={{ fontSize: "1.05rem", color: "#4a4a4a", lineHeight: "1.7", marginBottom: "1rem" }}>
                    <strong>Sensitive Information.</strong> We do not process sensitive information.
                  </p>

                  <p style={{ fontSize: "1.05rem", color: "#4a4a4a", lineHeight: "1.7" }}>
                    <strong>Payment Data.</strong> We may collect data necessary to process your payment. All payment data is handled and stored by Stripe. You may find their privacy notice at{" "}
                    <a href="https://stripe.com/privacy" target="_blank" rel="noopener noreferrer" style={{ color: "#08a040ff", textDecoration: "none" }}>
                      https://stripe.com/privacy
                    </a>.
                  </p>
                </section>

                {/* 2. How Do We Process Your Information */}
                <section style={{ marginBottom: "3rem" }}>
                  <h2 style={{ 
                    fontSize: "2rem", 
                    fontWeight: "700",
                    color: "#1a1a2e",
                    marginBottom: "1.5rem"
                  }}>
                    2. HOW DO WE PROCESS YOUR INFORMATION?
                  </h2>
                  
                  <p style={{ fontSize: "1.05rem", color: "#4a4a4a", lineHeight: "1.7", marginBottom: "1rem" }}>
                    <em>In Short:</em> We process your information to provide, improve, and administer our Services, communicate with you, for security and fraud prevention, and to comply with law.
                  </p>

                  <p style={{ fontSize: "1.05rem", color: "#4a4a4a", lineHeight: "1.7", marginBottom: "0.5rem" }}>
                    We process your personal information for a variety of reasons, including:
                  </p>

                  <ul style={{ fontSize: "1rem", color: "#4a4a4a", lineHeight: "1.8" }}>
                    <li className="mb-2">To facilitate account creation and authentication</li>
                    <li className="mb-2">To deliver and facilitate delivery of services to the user</li>
                    <li className="mb-2">To respond to user inquiries and offer support</li>
                    <li className="mb-2">To send administrative information to you</li>
                    <li className="mb-2">To protect our Services</li>
                    <li className="mb-2">To evaluate and improve our Services</li>
                    <li>To comply with our legal obligations</li>
                  </ul>
                </section>

                {/* 3. When and With Whom Do We Share */}
                <section style={{ marginBottom: "3rem" }}>
                  <h2 style={{ 
                    fontSize: "2rem", 
                    fontWeight: "700",
                    color: "#1a1a2e",
                    marginBottom: "1.5rem"
                  }}>
                    3. WHEN AND WITH WHOM DO WE SHARE YOUR PERSONAL INFORMATION?
                  </h2>
                  
                  <p style={{ fontSize: "1.05rem", color: "#4a4a4a", lineHeight: "1.7", marginBottom: "1rem" }}>
                    <em>In Short:</em> We may share information in specific situations described in this section.
                  </p>

                  <p style={{ fontSize: "1.05rem", color: "#4a4a4a", lineHeight: "1.7", marginBottom: "1rem" }}>
                    We may share your data with third-party vendors, service providers, contractors, or agents who perform services for us or on our behalf. The categories of third parties we may share personal information with include:
                  </p>

                  <ul style={{ fontSize: "1rem", color: "#4a4a4a", lineHeight: "1.8" }}>
                    <li>Cloud Computing Services</li>
                    <li>Data Analytics Services</li>
                    <li>Data Storage Service Providers</li>
                    <li>Finance & Accounting Tools</li>
                    <li>User Account Registration & Authentication Services</li>
                    <li>Payment Processors</li>
                  </ul>
                </section>

                {/* 6. How Long Do We Keep Your Information */}
                <section style={{ marginBottom: "3rem" }}>
                  <h2 style={{ 
                    fontSize: "2rem", 
                    fontWeight: "700",
                    color: "#1a1a2e",
                    marginBottom: "1.5rem"
                  }}>
                    6. HOW LONG DO WE KEEP YOUR INFORMATION?
                  </h2>
                  
                  <p style={{ fontSize: "1.05rem", color: "#4a4a4a", lineHeight: "1.7", marginBottom: "1rem" }}>
                    <em>In Short:</em> We keep your information for as long as necessary to fulfill the purposes outlined in this Privacy Notice unless otherwise required by law.
                  </p>

                  <p style={{ fontSize: "1.05rem", color: "#4a4a4a", lineHeight: "1.7" }}>
                    We will only keep your personal information for as long as it is necessary for the purposes set out in this Privacy Notice. No purpose in this notice will require us keeping your personal information for longer than six (6) months past the termination of the user's account.
                  </p>
                </section>

                {/* 7. How Do We Keep Your Information Safe */}
                <section style={{ marginBottom: "3rem" }}>
                  <h2 style={{ 
                    fontSize: "2rem", 
                    fontWeight: "700",
                    color: "#1a1a2e",
                    marginBottom: "1.5rem"
                  }}>
                    7. HOW DO WE KEEP YOUR INFORMATION SAFE?
                  </h2>
                  
                  <p style={{ fontSize: "1.05rem", color: "#4a4a4a", lineHeight: "1.7", marginBottom: "1rem" }}>
                    <em>In Short:</em> We aim to protect your personal information through a system of organizational and technical security measures.
                  </p>

                  <p style={{ fontSize: "1.05rem", color: "#4a4a4a", lineHeight: "1.7" }}>
                    We have implemented appropriate and reasonable technical and organizational security measures designed to protect the security of any personal information we process. However, despite our safeguards and efforts to secure your information, no electronic transmission over the Internet or information storage technology can be guaranteed to be 100% secure.
                  </p>
                </section>

                {/* 8. Do We Collect Information From Minors */}
                <section style={{ marginBottom: "3rem" }}>
                  <h2 style={{ 
                    fontSize: "2rem", 
                    fontWeight: "700",
                    color: "#1a1a2e",
                    marginBottom: "1.5rem"
                  }}>
                    8. DO WE COLLECT INFORMATION FROM MINORS?
                  </h2>
                  
                  <p style={{ fontSize: "1.05rem", color: "#4a4a4a", lineHeight: "1.7", marginBottom: "1rem" }}>
                    <em>In Short:</em> We do not knowingly collect data from or market to children under 18 years of age.
                  </p>

                  <p style={{ fontSize: "1.05rem", color: "#4a4a4a", lineHeight: "1.7" }}>
                    We do not knowingly collect, solicit data from, or market to children under 18 years of age. By using the Services, you represent that you are at least 18. If we learn that personal information from users less than 18 years of age has been collected, we will deactivate the account and take reasonable measures to promptly delete such data from our records.
                  </p>
                </section>

                {/* 9. What Are Your Privacy Rights */}
                <section style={{ marginBottom: "3rem" }}>
                  <h2 style={{ 
                    fontSize: "2rem", 
                    fontWeight: "700",
                    color: "#1a1a2e",
                    marginBottom: "1.5rem"
                  }}>
                    9. WHAT ARE YOUR PRIVACY RIGHTS?
                  </h2>
                  
                  <p style={{ fontSize: "1.05rem", color: "#4a4a4a", lineHeight: "1.7", marginBottom: "1rem" }}>
                    <em>In Short:</em> You may review, change, or terminate your account at any time.
                  </p>

                  <h3 style={{ fontSize: "1.3rem", fontWeight: "600", color: "#1a1a2e", marginBottom: "1rem" }}>
                    Account Information
                  </h3>

                  <p style={{ fontSize: "1.05rem", color: "#4a4a4a", lineHeight: "1.7", marginBottom: "0.5rem" }}>
                    If you would at any time like to review or change the information in your account or terminate your account, you can:
                  </p>

                  <ul style={{ fontSize: "1rem", color: "#4a4a4a", lineHeight: "1.8", marginBottom: "1rem" }}>
                    <li>Log in to your account settings and update your user account</li>
                    <li>Contact us using the contact information provided</li>
                    <li>Request account deletion by emailing us at{" "}
                      <a href="mailto:support@writeoffgenie.ai" style={{ color: "#08a040ff", textDecoration: "none" }}>
                        support@writeoffgenie.ai
                      </a>
                    </li>
                  </ul>
                </section>

                {/* 13. How Can You Contact Us */}
                <section style={{ marginBottom: "3rem" }}>
                  <h2 style={{ 
                    fontSize: "2rem", 
                    fontWeight: "700",
                    color: "#1a1a2e",
                    marginBottom: "1.5rem"
                  }}>
                    13. HOW CAN YOU CONTACT US ABOUT THIS NOTICE?
                  </h2>
                  
                  <p style={{ fontSize: "1.05rem", color: "#4a4a4a", lineHeight: "1.7", marginBottom: "0.5rem" }}>
                    If you have questions or comments about this notice, you may email us at{" "}
                    <a href="mailto:support@writeoffgenie.ai" style={{ color: "#08a040ff", textDecoration: "none" }}>
                      support@writeoffgenie.ai
                    </a>{" "}
                    or contact us by post at:
                  </p>

                  <address style={{ fontSize: "1.05rem", color: "#4a4a4a", lineHeight: "1.7", fontStyle: "normal" }}>
                    <strong>Swecha LLC</strong><br />
                    738 Spire Bend<br />
                    Apex, NC 27523<br />
                    United States
                  </address>
                </section>

                {/* 14. How Can You Review, Update, or Delete Data */}
                <section style={{ marginBottom: "3rem" }}>
                  <h2 style={{ 
                    fontSize: "2rem", 
                    fontWeight: "700",
                    color: "#1a1a2e",
                    marginBottom: "1.5rem"
                  }}>
                    14. HOW CAN YOU REVIEW, UPDATE, OR DELETE THE DATA WE COLLECT FROM YOU?
                  </h2>
                  
                  <p style={{ fontSize: "1.05rem", color: "#4a4a4a", lineHeight: "1.7" }}>
                    Based on the applicable laws of your country or state of residence in the US, you may have the right to request access to the personal information we collect from you, details about how we have processed it, correct inaccuracies, or delete your personal information. To request to review, update, or delete your personal information, please visit:{" "}
                    <a href="mailto:support@writeoffgenie.ai" style={{ color: "#08a040ff", textDecoration: "none" }}>
                      support@writeoffgenie.ai
                    </a>.
                  </p>
                </section>

              </Col>
            </Row>
          </motion.div>
        </Container>
      </div>

      <FooterSection />
    </>
  );
};

export default Privacy;